import * as tslib_1 from "tslib";
import { Router } from '@angular/router/';
var PasswordChangeGuard = /** @class */ (function () {
    function PasswordChangeGuard(_router) {
        this._router = _router;
    }
    PasswordChangeGuard.prototype.canActivate = function (route) {
        this._removeSensitiveURLData(route);
        return true;
    };
    PasswordChangeGuard.prototype._removeSensitiveURLData = function (route) {
        var _a = route.queryParams, code = _a.code, queryParams = tslib_1.__rest(_a, ["code"]);
        if (code) {
            this._router.navigate([
                '/account/passwordchange',
            ], {
                state: {
                    code: code,
                },
                queryParams: queryParams,
                replaceUrl: true,
            });
        }
    };
    return PasswordChangeGuard;
}());
export { PasswordChangeGuard };
